import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import WatchListModal from 'components/WatchListModal';
import StockAlertModal from 'components/StockAlertModal';
import MiniLoader from 'components/MiniLoader';
import StockAvatar from 'components/StockAvatar';

export default function ListStockSearch(props) {
    const { list = [], loading = false, onClickStock } = props;

    return (
        <div className="stock-search-dropdown" id="stock-search-dropdown">
            {loading && (
                <div className="stock-search-dropdown-status">
                    <MiniLoader />
                    <span>Buscando...</span>
                </div>
            )}

            {list.length > 0 && (
                <ul className="stock-search-list">
                    {list.map((item) => (
                        <li key={item.id || item.symbol} className="stock-search-item">
                            <RouterLink
                                to={`/stock/${item.symbol}`}
                                className="stock-search-link"
                                onClick={() => onClickStock(item)}
                            >
                                <StockAvatar
                                    item={item}
                                    symbol={item.symbol}
                                    className="stock-search-logo avatar-sm"
                                />
                                <div className="stock-search-meta">
                                    <span className="stock-search-symbol">{item.symbol}</span>
                                    <span className="stock-search-name">{item.name || item.symbol}</span>
                                </div>
                            </RouterLink>
                            <div
                                className="stock-search-action"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <WatchListModal symbol={item.symbol} />
                                <StockAlertModal
                                    symbol={item.symbol}
                                    currentPrice={item.ask || item.bid}
                                    item={item}
                                    buttonClassName="icon-button stock-watchlist-btn"
                                    iconSize={18}
                                />
                            </div>
                        </li>
                    ))}
                </ul>
            )}

            {!loading && list.length === 0 && (
                <div className="stock-search-dropdown-status stock-search-dropdown-empty">
                    No se encontraron resultados
                </div>
            )}
        </div>
    );
}
